/*
 * @Descripttion:
 * @version: 1.0
 * @Author: Erik Zhang
 * @Date: 2020-08-05 09:08:11
 * @LastEditors: Erik Zhang
 * @LastEditTime: 2021-02-12 21:46:36
 */
let loading;
const date = {
  loading: null, //定义loading变量
  get() {},
  start() {},
  close() {},
};

export default date;
